<template>
  <div class="demo">
    <rc-form :form="form" :data="formData" :form-item="formItem" :show-search="showSearch" @change="formChange">
      <template #split-line>
        <div class="line">-</div>
      </template>
      <template #createBtn>
        立即创建2 <i class="el-icon-upload el-icon--right"></i>
      </template>
      <template #nameSuffix>
        <i class="el-input__icon el-icon-date"></i>
      </template>
      <template #regionPrefix>
        <i class="el-icon-upload"></i>
      </template>
      <template #regionDefault>
        <el-option label="自定义下拉" value="选项1"></el-option>
      </template>
      <template #cascaderDefault="{ node, data }">
        <span>{{ data.label }}</span>
        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
      </template>
    </rc-form>
  </div>
</template>

<script>
const checkAge = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("年龄不能为空"));
  }
  setTimeout(() => {
    if (value < 18) {
      callback(new Error("必须年满18岁"));
    } else {
      callback();
    }
  }, 1000);
};
export default {
  name: "TestForm",
  data() {
    return {
      showSearch: false,
      form: {
        inline: false,
        labelWidth: "100px",
        gutter: 20,
        labelPosition: "left"
      },
      formData: {
        name: "",
        age: "",
        region: "",
        date1: "",
        date2: "",
        date3: "",
        date4: "",
        delivery: false,
        slider: [30, 60],
        rate: 3.7,
        colorPicker: "",
        type: [],
        resource: "",
        testRadio: "",
        cascader: [],
        testCheckbox: "",
        desc: ""
      },
      formItem: [
        {
          component: "rc-input",
          prop: "name",
          label: "活动名称",
          rules: [
            { required: true, message: "请输入活动名称", trigger: "change" },
            { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "change" }
          ],
          events: {
            change: this.handleInputChange
          }
        },
        {
          component: "rc-input",
          prop: "age",
          label: "年龄校验",
          rules: [
            { min: 1, max: 3, message: "年龄不能超过三位数", trigger: "change", required: true },
            { validator: checkAge, trigger: "change" }
          ]
        },
        {
          component: "rc-select",
          prop: "region",
          label: "活动区域",
          placeholder: "请选择活动区域",
          options: [
            { label: "区域一", value: "shanghai" },
            { label: "区域二", value: "beijing" }
          ],
          rules: [
            { required: true, message: "请选择活动区域", trigger: "change" }
          ],
          events: {
            change: this.handleChange
          }
        },
        {
          label: "活动日期",
          required: true,
          children: [
            { component: "rc-date-picker", prop: "date1", placeholder: "选择日期", span: 5, rules: [{ type: "date", required: true, message: "请选择日期", trigger: "change" }] },
            { component: "slot", slotName: "split-line", span: 1 },
            { component: "rc-time-picker", prop: "date2", placeholder: "选择时间", span: 5, rules: [{ type: "date", required: true, message: "请选择时间", trigger: "change" }] },
            { component: "slot", slotName: "split-line", span: 1 },
            { component: "rc-time-select", prop: "date3", placeholder: "选择时间点", span: 5 },
            { component: "slot", slotName: "split-line", span: 1 },
            { component: "rc-date-picker", prop: "date4", startPlaceholder: "开始月份", endPlaceholder: "结束月份", type: "monthrange", span: 6 }
          ]
        },
        {
          component: "rc-switch",
          prop: "delivery",
          label: "即时配送"
        },
        {
          component: "rc-slider",
          label: "滑块",
          prop: "slider",
          range: true,
          marks: {
            0: "0°C",
            8: "8°C",
            37: "37°C",
            50: {
              style: {
                color: "#1989FA"
              },
              label: this.$createElement("strong", "50%")
            }
          }
        },
        {
          component: "rc-rate",
          label: "推荐排行",
          prop: "rate"
        },
        // {
        //   component: 'rc-color-picker',
        //   label: '颜色选择',
        //   prop: 'colorPicker'
        // },
        {
          component: "rc-checkbox-group",
          prop: "type",
          label: "活动性质",
          options: [
            { label: "美食/餐厅线上活动", value: "美食/餐厅线上活动" },
            { label: "地推活动", value: 2 },
            { label: "线下主题活动", value: 3 },
            { label: "单纯品牌曝光", value: 4 }
          ],
          rules: [
            { type: "array", required: true, message: "请至少选择一个活动性质", trigger: "change" }
          ]
        },
        {
          component: "rc-radio",
          prop: "testRadio",
          label: "单选",
          text: "测试单选文本"
        },
        {
          component: "rc-checkbox",
          prop: "testCheckbox",
          label: "多选",
          text: "测试多选"
        },
        {
          component: "rc-cascader",
          prop: "cascader",
          label: "级联选择",
          options: [{
            value: "zhinan",
            label: "指南",
            children: [{
              value: "shejiyuanze",
              label: "设计原则",
              children: [{
                value: "yizhi",
                label: "一致"
              }, {
                value: "fankui",
                label: "反馈"
              }, {
                value: "xiaolv",
                label: "效率"
              }, {
                value: "kekong",
                label: "可控"
              }]
            }, {
              value: "daohang",
              label: "导航",
              children: [{
                value: "cexiangdaohang",
                label: "侧向导航"
              }, {
                value: "dingbudaohang",
                label: "顶部导航"
              }]
            }]
          }]
        },
        {
          component: "rc-radio-group",
          prop: "resource",
          label: "特殊资源",
          options: [
            { label: "线上品牌商赞助" },
            { label: "线下场地免费" }
          ],
          rules: [{ required: true, message: "请选择活动资源", trigger: "change" }]
        },
        {
          component: "el-input",
          type: "textarea",
          prop: "desc",
          label: "活动形式",
          required: false,
          rules: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
        },
        {
          gutter: 30,
          children: [
            { component: "rc-button", type: "primary", span: 4, slotName: "createBtn" },
            { component: "rc-button", text: "重置", span: 2 },
            { component: "rc-button", icon: "el-icon-edit", span: 2 }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
  .demo {
    padding: 20px;
  }

  .line {
    text-align: center;
  }
</style>
